import { useLanguage } from "@/context/LanguageContext";
import { content } from "@/i18n/content";
import { Reveal } from "@/components/Reveal";

const IdentityStrip = () => {
  const { pick } = useLanguage();
  return (
    <section data-testid="identity-strip" className="bg-[#171717] text-[#F7F5F0] border-b border-[#F7F5F0]/10">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 px-6 md:px-12 lg:px-24">
        {content.identity.map((item, i) => (
          <Reveal
            key={i}
            delay={i * 0.08}
            className={`py-8 lg:py-10 lg:px-8 first:lg:pl-0 ${
              i > 0 ? "border-t sm:border-t-0 lg:border-l border-[#F7F5F0]/15" : ""
            } ${i % 2 === 1 ? "sm:border-l sm:pl-8 lg:pl-8" : ""}`}
          >
            <p className="text-[10px] font-semibold uppercase tracking-[0.26em] text-[#F7F5F0]/50">
              {pick(item.label)}
            </p>
            <p data-testid={`identity-value-${i}`} className="mt-2 font-display text-xl md:text-2xl tracking-tight">
              {pick(item.value)}
            </p>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default IdentityStrip;
